var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalExamNo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17534",
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12986",
    d: "M7.11 5.493L4.34 2.72",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12987",
    d: "M2.66 4.4l2.767 2.773",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12988",
    d: "M8.7 3.907l-4.867 4.86",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12989",
    d: "M11.567 11.634L14 14.067",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12990",
    d: "M11.08 8.234l-.973.973",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12992",
    d: "M5.033 2.027L2 5.06",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12993",
    d: "M7.922 10.962l1.206 1.229a1.333 1.333 0 001.885 0l1.071-1.07a1.333 1.333 0 000-1.885c-.521-.521-1.32-1.338-1.32-1.338",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12996",
    d: "M7.113 10.079L4.559 7.545"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12997",
    d: "M9.858 6.979l-2.3-2.255"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12994",
    d: "M16 0H0v16h16z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12995",
    d: "M12.55 4.12l-8.48 8.316",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgMedicalExamNo;


//////////////////
// WEBPACK FOOTER
// ./src/icons/medicalExam-no.svg
// module id = 777
// module chunks = 13